import { useMemo } from 'react';

import { HTMLParagraph } from '@/components/HTMLParagraph';
import { Paragraph } from '@/components/Paragraph';

import { StyledTip, StyledTipImage } from './styles';

import type { Content } from '@/types/content';

interface ItineraryTipProps {
  content: Content;
}

export function ItineraryTip({ content }: ItineraryTipProps) {
  const tipImage = useMemo(() => {
    const imageContent = content.RichContent?.find((item) => item.type.toLowerCase() === 'image')?.path;
    return imageContent;
  }, [content]);

  return (
    <StyledTip>
      <StyledTipImage src={tipImage} />
      <Paragraph size="lg" weight={700}>
        {content.header}
      </Paragraph>
      <HTMLParagraph dangerousHTML={content.paragraph ?? ''} />
    </StyledTip>
  );
}
